//$('#element').foundation('open');
sendEmailHandler = {
    actionID = 0,
    sendType = 'report',
    $sendMail =  $('#send-mail'),  
    $triggerStartSend = $('.trigger-start-send'),
    $emailTo = $('#email-to'),
    $sendMailInputContainer = $('.send-mail-input-container'),

    sendMail = function(){
        var self = this;
        var mailTo = self.$emailTo.val();
        if (mailTo) {
            self.$sendMailInputContainer.addClass('disable');
            $.ajax({
                type: 'post',
                url: myAjax.ajax_url,
                data: {
                    action: 'send_mail',
                    send_type: self.sendType,
                    action_id: self.actionID,
                    mail_to: mailTo
                },
                success: function(response) {
                    if (response['state'] == 'true') {
                        alert('PDF has been sent to your email.');
                    } else {
                        if (response['error']) {
                            alert(response['error']);
                        } else {
                            alert('Send email has failed.');
                        }
                    }
                    self.$emailTo.val('');
                    self.$sendMailInputContainer.removeClass('disable');
                }
            });
        } else {
            alert('Please fill email address.');
        }
    },

    init = function(){
        var self = this;

        $('.email-report').on('click', function(e){
            e.preventDefault();
            menuNavHandler.closeMenu();
            self.actionID = $(this).data('action-id');
            self.sendType = $(this).data('send-type');
            if (!self.sendType) self.sendType = 'report';
            self.$sendMail.foundation();
            self.$sendMail.foundation('toggle');
        })

        this.$triggerStartSend.on('click', function(){
            self.sendMail();
        })

    }
}